module.exports = __webpack_public_path__ + "img/167.8ed9d7e4.jpg";